import type { Job } from '@kanda-libs/ks-frontend-services';

export interface ContainerComponentChildrenArgs {
  showInclusice?: number;
  total: number;
  deposit: number | null;
}

export interface ContainerComponentProps {
  job?: Job;
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
}

const ContainerComponent = ({ children, job }: ContainerComponentProps) => {
  const totals = job?.total;
  const total = totals?.amount_vat_inclusive?.amount || 0;
  const showInclusice = totals?.amount_vat?.amount;
  const deposit =
    job?.customer_options?.deposit_value?.amount ||
    job?.deposit_value?.amount ||
    null;

  return children({
    showInclusice,
    total,
    deposit,
  });
};

ContainerComponent.displayName = 'JobSidebar-Totals-container';

export default ContainerComponent;
